<app-order-point-base-form
  [form]="form()"
  [isCompleted]="isCompleted()"
  [disabled]="disabled()"
></app-order-point-base-form>

<onyx-input-label
  class="goods-label"
  [label]="`${I18N}.goodsToLoad` | translate"
></onyx-input-label>

<div class="goods">
  @for (control of goodsFormArray().controls; track control) {
    <app-order-loading-point-good-form
      [form]="control"
      [first]="$first"
      [goods]="goods()"
      [parametersValidation]="parametersValidation()"
      (remove)="removeGood($index)"
    ></app-order-loading-point-good-form>
  }
</div>

<onyx-button
  class="add-good-button"
  variant="outlined"
  [size]="32"
  leftIcon="add-outlined"
  (click)="addGood()"
>
  {{ `${I18N}.addGood` | translate }}
</onyx-button>

<app-order-point-information-form
  [form]="form()"
></app-order-point-information-form>
